import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { styled } from '@mui/material';

import { QuestionAnswerForm } from 'common/securityQuestion/QuestionAnswerForm';
import { BlackText, HeadingText } from 'common/typography/typography';
import CIStepper from 'common/viewcomp/stepper/CIStepper';

interface Props {
    activeStep: number;
    onCompleteStep: () => void;
    onBackToLogin?: () => void;
}

export const SecurityQuestionUserActivation = ({ onCompleteStep, onBackToLogin, activeStep }: Props): ReactElement => {
    const { t } = useTranslation('user');
    const { t: tPatientApp } = useTranslation('patientApp');

    return (
        <Container>
            <HeadingText style={{ fontSize: '1.8rem' }}>{t('activation.security_question_step')}</HeadingText>
            <CIStepper activeStep={activeStep} />

            <div style={{ maxWidth: '440px' }}>
                <div style={{ paddingBottom: '18px' }}>
                    <BlackText>{t('activation.security_question_description')}</BlackText>
                </div>
                <QuestionAnswerForm
                    questions={{
                        securityQuestion1Text: '',
                        securityQuestion2Text: '',
                        securityQuestion3Text: '',
                    }}
                    t={tPatientApp}
                    onUpdateSuccess={onCompleteStep}
                    labels={{
                        submit: t('activation.finish_button'),
                    }}
                    options={{ isActivationFlow: true, noAuthUpdate: true }}
                    onBackToLogin={onBackToLogin}
                />
            </div>
        </Container>
    );
};

const Container = styled('div')(({ theme }) => ({
    width: '480px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: theme.ciPalette.background.fullWhite,
    borderRadius: '4px',
    padding: '16px',
    boxShadow: `0px 15px 60px ${theme.ciPalette.common.shadow}`,
}));
